import { axiosInstance } from '../config';
import { LoginData } from '../../pages/online-user/components/loging/types';

export const logins = {
	getUserLogins(params: LoginData) {
		return axiosInstance.post('/support/login_records/user_logs', params).then(({ data }) => data);
	},
};
